import common from './common';
import hasCarousel from './hasCarousel';
import hasForm from './hasForm';
import hasIsotope from './hasIsotope';
import hasMap from './hasMap';
import hasOffCanvas from './hasOffCanvas';
import hasParallax from './hasParallax';
import hasVideo from './hasVideo';
import woocommerce from './woocommerce';

export default {
  common,
  hasCarousel,
  hasForm,
  hasIsotope,
  hasMap,
  hasOffCanvas,
  hasParallax,
  hasVideo,
  woocommerce,
};



// WEBPACK FOOTER //
// /Users/dcsturm/wrk/packages/composer/zd-wp-sage-lib/resources/assets/scripts/routes/index.js